import { isMobile } from "react-device-detect";
import MobileRoutes from "./MobileRoutes";
import PCRoutes from "./PCRoutes";
import { PCNoFrameworkRoutes } from "./PCRoutes";
import { MobileNoFrameworkRoutes } from "./MobileRoutes";

export default isMobile ? MobileRoutes : PCRoutes
export const NoFrameworkRoutes = isMobile ? MobileNoFrameworkRoutes : PCNoFrameworkRoutes